import { useMutation } from '@tanstack/react-query';
import api from './api';

export const useAddRefMutation=()=>{
  return useMutation({
    mutationFn:async({userId,refEmail})=>{
     const res= await api.put(`/user/addRef/${userId}/${refEmail}`)
      return res.data
    }
  })
}